// extracted by mini-css-extract-plugin
export var activityContainer = "_n8-0";
export var typingIndicatorContainer = "_n8-1";
export var typingIndicatorDot = "_n8-2";
export var wave = "_n8-3";